'use strict';
// var moment = require('moment');

module.exports = [
  '$filter',
  TimeFormatDirective];

function TimeFormatDirective($filter) {
  return {
    require: '^ngModel',
    restrict: 'A',
    link: function ($scope, $element, $attrs, ngModelCtrl) {
      const dateFormat = $attrs.timeFormat;

      // attrs.$observe('timeFormat', function (newValue) {
      //  if (dateFormat === newValue || !ngModelCtrl.$modelValue) return;
      //  dateFormat = newValue;
      //  ngModelCtrl.$modelValue = new Date(ngModelCtrl.$setViewValue);
      // });

      ngModelCtrl.$formatters.unshift(function (modelValue) {
        if (!dateFormat || !modelValue) return modelValue;
        return $filter('date')(modelValue, dateFormat);
      });

      // ngModelCtrl.$parsers.unshift(function (viewValue) {
      //  var date = moment(viewValue, dateFormat);
      //  return (date && date.isValid() && date.year() > 1950 ) ? date.toDate() : "";
      // });
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/calendar/TimeFormatDirective.js